import React, { useState } from "react";
import { Stack, Typography, Button } from "@mui/material";
import CustomSimpleAccordion from "qubCommon/Accordions/CustomSimpleAccordion";
import PaymentsTable from "./PaymentsTable";
import NewPaymentDialog from "./NewPaymentDialog";
import { Payment } from "@mui/icons-material";
import PaymentPreviewDialog from "./PaymentPreviewDialog";

const Payments = ({ data, canAddNewPayment = false, fetchClearings, seasonId }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);


  return (
    <CustomSimpleAccordion
      defaultOpen
      title={
        <Stack direction="row" gap={1}>
          <Payment color="primary" fontSize="small" sx={{ marginLeft: "2px" }} />
          <Typography variant='h4' color="primary" sx={{ fontWeight: 700 }}>
            Αποφάσεις Εκταμίευσης (Πληρωμές)
          </Typography>
        </Stack>
      }
      content={
        <Stack spacing={2}>
          <PaymentsTable rows={data} onPreview={(row) => {
            setSelectedPayment(row);
          }} />

          <Button
            variant="contained"
            color="primary"
            disabled={!canAddNewPayment}
            onClick={() => setOpenDialog(true)}
            sx={{
              width: { xs: "100%", sm: "auto" },
              alignSelf: { sm: "flex-start" },
              px: 4,
            }}
          >
            Νέα Πληρωμή
          </Button>

          <NewPaymentDialog
            seasonId={seasonId}
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            fetchClearings={fetchClearings}
          />
          <PaymentPreviewDialog
            open={Boolean(selectedPayment)}
            onClose={() => setSelectedPayment(null)}
            row={selectedPayment}
          />
        </Stack>
      }
    />
  );
};

export default Payments;
